<template>
  <div
    id="divAtigimento"
  >
    <div
      v-if="loading"
      id="carregaDados"
      class="text-center"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando Dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div
      v-else
      id="legendaTimeAtigimentoMeta"
      class="text-center px-3"
    >
      <div v-if="text">
        <h3>{{ text }}</h3>
      </div>
      <div v-else>
        <v-row>
          <div
            v-for="legenda in legenda"
            :key="legenda.text"
          >
            <v-avatar
              class="mr-1"
              :color="legenda.cor"
              size="12"
            />
            <span class="mr-3 font-weight-light">{{ legenda.text }}</span>
          </div>
        </v-row>
      </div>
    </div>
    <canvas
      id="myChart14"
      width="70"
      height="50"
    />
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import Time from '../../../../services/time'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardAtigimentoMetaProgresso',
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },

    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      colors: [],
      myChart: {},
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      supervisor: [],
      receita: [],
      segmento: [],
      rede: [],
      categoria: [],
      promotor: [],
      classificacao: [],
      vendedor: [],
      text: null,
      montarGrafico: true,
      loading: false,
      error: null,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      legenda: [],
    }),

    created () {
      eventEmit.$on('update-time', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-time', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, supervisor, receita, segmento, rede, categoria, promotor, classificacao, vendedor) {
        this.primeiroDia = primeiroDia
        this.dataFinal = dataFinal
        this.select = select
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.rede = rede
        this.categoria = categoria
        this.promotor = promotor
        this.classificacao = classificacao
        this.vendedor = vendedor

        this.atualizaGrafico()
      },

      async atualizaGrafico () {
        this.loading = true
        this.error = null
        this.text = null

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await Time.showAtigimentoMetaPeriodo(this.primeiroDia, this.dataFinal, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.segmento, this.rede, this.categoria, this.promotor, this.classificacao, this.vendedor).then(resposta => {
          if (resposta.data.status) {
            const setPerson = new Set()

            this.legenda = resposta.data.legenda.filter((person) => {
              const duplicatedPerson = setPerson.has(person.text)
              setPerson.add(person.text)
              return !duplicatedPerson
            })

            const ctx = document.getElementById('myChart14').getContext('2d')

            this.myChart = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.datas,
                datasets: [
                  {
                    label: 'Faturamento',
                    data: resposta.data.faturamento,
                    backgroundColor: resposta.data.colors,
                    order: 1,
                  },
                  {
                    label: 'Tendencia',
                    data: resposta.data.tendenciaExibicao,
                    backgroundColor: '#cadaed',
                    order: 2,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    mode: 'label',
                    label: (tooltipItem, data) => {
                      return ['Faturamento Acumulado: ' + resposta.data.faturamento[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                              'Meta Diária Acumulada: ' + resposta.data.metaDiaria[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                              'Tendência Acumulada: ' + resposta.data.tendencia[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })]
                    },
                    title: (tooltipItem) => {
                      return [tooltipItem[0].label, '____________________________________']
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há faturamento para o período selecionado.') {
            this.text = resposta.data.msg

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Não há meta no período selecionado') {
            this.text = resposta.data.msg

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 4000, 'Erro ao exibir gráfico atigimento meta por período. ' + resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.msg)
          }
        }).finally(f => { this.loading = false })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style lang="sass">
  #divAtigimento
    margin: 3rem 0 0 0

</style>

<style scoped>
 .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 600px) {
    #myChart14 {
      margin: 1rem 0 2rem 0;
      /* width: 420px !important;
      height: 280px !important; */
    }

    #legendaTimeAtigimentoMeta {
      font-size: 10px;
      margin: -4rem 0 0 2rem
    }
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #myChart14 {
      margin: 0 0 0 0;
      /* width: 800px !important;
      height: 460px !important; */
    }

    #legendaTimeAtigimentoMeta {
      font-size: 14px;
      margin: -3rem 0 0 18rem;
    }
  }
</style>
